import { render } from "./LiveMarketTicker.vue?vue&type=template&id=ac210b94&scoped=true"
import script from "./LiveMarketTicker.vue?vue&type=script&lang=js"
export * from "./LiveMarketTicker.vue?vue&type=script&lang=js"

import "./LiveMarketTicker.vue?vue&type=style&index=0&id=ac210b94&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac210b94"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QSeparator,QIcon});
